import PropTypes from 'prop-types'
import LinearProgress from '@mui/material/LinearProgress'

import styles from './MigrationProgress.module.scss'

// Etiquetas legibles para las fases y tablas tecnicas.
const PHASE_LABEL = {
  deleting: 'Borrando',
  copying: 'Copiando',
  idle: ''
}

const TABLE_LABEL = {
  MEASURES: 'Medidas',
  MEASURE_LATEST: 'Última medida',
  DAY_MEASURES: 'Medidas (día)',
  DAILY_MEASURES: 'Medidas diarias',
  WEEKLY_MEASURES: 'Medidas semanales',
  MONTHLY_MEASURES: 'Medidas mensuales',
  HOURLY_MEASURES: 'Medidas horarias',
  QUARTLY_MEASURES: 'Medidas (15 min)',
  TENLY_MEASURES: 'Medidas (10 min)',
  DAILY_STATISTICS: 'Estadísticas diarias',
  WEEKLY_STATISTICS: 'Estadísticas semanales',
  MONTHLY_STATISTICS: 'Estadísticas mensuales',
  HOURLY_STATISTICS: 'Estadísticas horarias',
  MONTHLY_INDICATORS: 'Indicadores mensuales',
  SCREEN: 'Pantallas',
  ALARM: 'Alarmas',
  INACTIVITY_ALARM: 'Alarmas de inactividad'
}

// Componente reutilizable de barra de progreso para migracion y chatarrizacion.
// Acepta el objeto `progress` que devuelven los endpoints */state:
//   migrate:     { tablesDone, tablesTotal, currentTable, phase, percent, counters:{deleted,copied} }
//   chatarrizar: { stepsDone,  stepsTotal,  currentTable, phase, percent, counters:{deleted} }
export const MigrationProgress = ({ progress }) => {
  if (!progress) return null

  const done = progress.tablesDone ?? progress.stepsDone ?? 0
  const total = progress.tablesTotal ?? progress.stepsTotal ?? 0
  const percent =
    typeof progress.percent === 'number'
      ? progress.percent
      : total > 0
      ? Math.floor((done * 100) / total)
      : 0

  const counters = progress.counters || {}
  const phaseLabel = PHASE_LABEL[progress.phase] || ''
  const tableLabel = progress.currentTable
    ? TABLE_LABEL[progress.currentTable] || progress.currentTable
    : ''

  const detailParts = []
  if (total > 0) detailParts.push(`${done}/${total}`)
  if (phaseLabel && tableLabel) detailParts.push(`${phaseLabel} ${tableLabel}`)
  if (counters.deleted) detailParts.push(`borradas ${counters.deleted.toLocaleString('es-ES')}`)
  if (counters.copied) detailParts.push(`copiadas ${counters.copied.toLocaleString('es-ES')}`)

  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressBarRow}>
        <LinearProgress
          variant='determinate'
          value={Math.min(Math.max(percent, 0), 100)}
          className={styles.progressBar}
        />
        <span className={styles.percent}>{Math.min(Math.max(percent, 0), 100)}%</span>
      </div>
      {detailParts.length > 0 && <small className={styles.detail}>{detailParts.join(' · ')}</small>}
    </div>
  )
}

MigrationProgress.propTypes = {
  progress: PropTypes.shape({
    tablesDone: PropTypes.number,
    tablesTotal: PropTypes.number,
    stepsDone: PropTypes.number,
    stepsTotal: PropTypes.number,
    currentTable: PropTypes.string,
    phase: PropTypes.string,
    percent: PropTypes.number,
    counters: PropTypes.object
  })
}

export default MigrationProgress
